import(/* webpackMode: "eager", webpackExports: ["ProductsClient"] */ "/opt/buildhome/repo/app/(main)/products/ProductsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductNavTabsSeed"] */ "/opt/buildhome/repo/components/products/nav/ProductNavTabsSeed.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
